'use client';

import { useState } from 'react';
import { Image } from '@petsmart-ui/sparky';
import { buildScene7StaticId, getScene7StaticUrl } from '../../utils/scene7Static';
import { getENV } from '../../utils/env';

export interface Scene7ImageProps {
    src: string;
    alt: string;
    className?: string;
    width?: number;
    height?: number;
    loading?: 'eager' | 'lazy';
    scene7Query?: string;
    testId?: string;
}

export function Scene7Image(props: Scene7ImageProps) {
    const { src, alt, className, width, height, loading = 'lazy', scene7Query, testId } = props;
    const skipAsset = src.toLowerCase().endsWith('.svg') || src.toLowerCase().endsWith('.gif');
    const candidateBase = skipAsset ? src : getScene7StaticUrl(buildScene7StaticId(src));
    const candidate = scene7Query && !skipAsset ? `${candidateBase}?${scene7Query}` : candidateBase;

    const [useFallback, setUseFallback] = useState(false);
    const displaySrc = useFallback ? `/${getENV('NEXT_PUBLIC_APP_NAME')}${src}` : candidate;
    const preloadHref = loading === 'eager' ? displaySrc : undefined;

    const handleError = () => {
        // Only flip to fallback once and only when candidate differs from original
        if (!useFallback && candidate !== src) {
            setUseFallback(true);
        }
    };

    return (
        <>
            {preloadHref && <link rel="preload" key={preloadHref} href={preloadHref} as="image" />}
            <Image
                data-testid={testId}
                key={displaySrc}
                src={displaySrc}
                alt={alt}
                className={className}
                width={width}
                height={height}
                loading={loading}
                onError={handleError}
            />
        </>
    );
}
